import React,{useEffect,useState} from "react";

import ContactCell from "./ContactCell/index";

const ContactList = (props) => {

  return (
    <div style={props.disabledPage ? {pointerEvents: "none", opacity: "0.4"} : {}} className="gx-contact-main-content">
        {props.contactList.map((contact, index) =>
          <ContactCell key={index} userId={props.userId} contact={contact} sendDataForUpdate={(val,isChecked) => {props.getDataComp(val,isChecked)}} tab={props.tab}/>
        )}
    </div>
  )
};

export default ContactList;
